<template>
    <div class="course__show_content">
        <template v-if="notifyClosed">
            <component-note :class="'course__show_content_feedbackformnote'">The course will be marked as complete once you fill in the feedback form below.</component-note>
        </template>
        <template v-if="courseModules.length">
            <component-modules
                :modules="courseModules"
            ></component-modules>
        </template>
        <template v-else>
            <component-empty-state
                :item="'module'"
                :title="'No modules have been added to this course yet.'"
                :submit-button-active="false"
            />
        </template>
        <pop-notify
            ref="popnotifyopenfeedback"
            :class="'pop__notify--openfeedback'"
            :title-text="`Awaiting feedback`"
            :content-text="'Congratulations, you have completed all the modules!\n\n To complete the course please fill in the feedback form.\n'"
            :cancel-button-text="'Do it later'"
            :submit-button-text="'Open form'"
            @emit-close="setNotifyClosedValue(true)"
            @emit-submit="performOpenFeedbackForm"
        />
        <template v-if="hasFeedbackForm && isUserEnrolled && routeIsCourseVersionView">
            <component-course-feedback-form
                ref="feedbackformcomponent"
                :feedback-form-id="catalogItemFeedbackForm"
                :disabled="!showFeedbackForm"
                @emit-submit="setNotifyClosedValue(false)"
            ></component-course-feedback-form>
        </template>
    </div>
</template>

<script>
import ComponentModules from '@/components/default/shared/ComponentModules'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'
import ComponentCourseFeedbackForm from '@/components/default/shared/ComponentCourseFeedbackForm'
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentNote from '@/components/default/shared/ComponentNote'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  name: 'course-show-content',
  components: { ComponentLoading, ComponentNote, PopNotify, ComponentCourseFeedbackForm, ComponentEmptyState, ComponentModules },
  data () {
    return {
      notifyClosed: false,
      courseExtendModulesRequestCompleted: false,
      courseHistoryRequestCompleted: false
    }
  },
  computed: {
    courseModules () {
      const modules = this.$store.getters.getEbsCourseModules
      return this.$route.name === 'ebs-course-show' ? modules : (modules.length ? modules[0].nodes : modules)
    },
    catalogItemFeedbackForm () {
      return this.$store.getters.getEbsCatalogItemFeedbackForm
    },
    hasFeedbackForm () {
      const catalogItemFeedbackForm = this.catalogItemFeedbackForm

      return catalogItemFeedbackForm !== undefined && catalogItemFeedbackForm !== null
    },
    routeIsCourseVersionView () {
      return this.$route.name === 'ebs-course-version-show'
    },
    routeIsCourseEnrolmentView () {
      return this.$route.name === 'ebs-course-enrolment-show'
    },
    learnerEnrolmentStatus () {
      return this.$store.getters.getEbsCatalogItemLatestEnrolmentState
    },
    isUserEnrolled () {
      return this.$store.getters.getEbsEnrolmentIsUserEnrolled
    },
    showFeedbackForm () {
      return (
        this.hasFeedbackForm &&
      this.routeIsCourseVersionView &&
      this.learnerEnrolmentStatus === 'awaiting_feedback'
      )
    }
  },
  watch: {
    showFeedbackForm (value) {
      if (value) {
        this.openFillFeedbackFormNotify()
      }
    }
  },
  methods: {
    performOpenFeedbackForm () {
      this.$nextTick(() => {
        this.setNotifyClosedValue(false)
      })
      if (this.$refs.feedbackformcomponent) {
        this.$refs.feedbackformcomponent.openFeedbackForm()
      }
    },
    openFillFeedbackFormNotify () {
      this.$refs.popnotifyopenfeedback.openNotify()
    },
    setNotifyClosedValue (data) {
      this.notifyClosed = data
    }
  },
  mounted () {
    if (this.showFeedbackForm) {
      this.openFillFeedbackFormNotify()
    }
  },
  created () {
    this.$eventBus.$on('ebs-course-extend-modules', () => this.courseExtendModulesRequestCompleted = true)
    this.$eventBus.$on('ebs-course-get-history', () => this.courseHistoryRequestCompleted = true)
  },
  beforeDestroy () {
    this.$eventBus.$off('ebs-course-extend-modules')
    this.$eventBus.$off('ebs-course-get-history')
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseshowcontent";
</style>
